import React, { ReactNode } from 'react';
import classNames from 'classnames';
import HelpIcon from '@moda/icons/help-16';
import { Popover, PopoverProps } from '@moda/om';
import './PaymentSummaryRow.scss';

interface Props {
  label: ReactNode;
  value: ReactNode;
  tooltip?: ReactNode;
  tooltipAnchor?: PopoverProps['anchor'];
  hasBillFailure?: boolean;
}

export const PaymentSummaryRow: React.FC<Props> = ({
  label,
  value,
  tooltip,
  tooltipAnchor = 'bottomLeft',
  hasBillFailure
}) => {
  const dataTestIdLabel = String(label).replace(/\s/g, '');

  return (
    <div
      className={classNames('PaymentSummaryRow', {
        'PaymentSummaryRow--error': hasBillFailure
      })}
    >
      <span className="PaymentSummaryRow__label">
        <span data-testid={`PaymentSummaryRow__label-${dataTestIdLabel}`}>{label}</span>
        {tooltip && (
          <Popover
            anchor={tooltipAnchor}
            content={<div className="PaymentSummaryRow__tooltip">{tooltip}</div>}
          >
            <HelpIcon />
          </Popover>
        )}
      </span>
      <span data-testid={`PaymentSummaryRow__value-${dataTestIdLabel}`}>{value}</span>
    </div>
  );
};
